var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-magazine"},[_c('BreadCrumb',{attrs:{"data":_vm.breadcrumb,"title":'杂志列表管理'}}),_vm._v(" "),_c('StatisticalPanel',{attrs:{"whichModule":'guihua',"data":_vm.overallData}}),_vm._v(" "),_c('div',{staticClass:"pc-magazine-table"},[_c('NewMagazineTable')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef76f856","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/guihua/newMagazine.vue
// module id = xNGe
// module chunks = 0